import { useMemo } from 'react'
import { isSpaceStreamId, Membership } from '@towns-protocol/sdk'
import { useMyMemberships } from 'use-towns-client'

export function useMySpaceStreams() {
    const myStreamMemberships = useMyMemberships()

    const mySpaceStreams: { joined: string[]; left: string[] } = useMemo(() => {
        return Object.keys(myStreamMemberships)
            .filter((streamId) => {
                return isSpaceStreamId(streamId)
            })
            .reduce(
                (acc, streamId) => {
                    if (myStreamMemberships[streamId] === Membership.Join) {
                        acc.joined.push(streamId)
                    } else {
                        acc.left.push(streamId)
                    }
                    return acc
                },
                {
                    joined: [],
                    left: [],
                } as { joined: string[]; left: string[] },
            )
    }, [myStreamMemberships])

    return mySpaceStreams
}
